"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "RequestError", {
  enumerable: true,
  get: function get() {
    return _umiRequest.RequestError;
  }
});
Object.defineProperty(exports, "ResponseError", {
  enumerable: true,
  get: function get() {
    return _umiRequest.ResponseError;
  }
});
exports.default = void 0;
Object.defineProperty(exports, "extend", {
  enumerable: true,
  get: function get() {
    return _umiRequest.extend;
  }
});
Object.defineProperty(exports, "request", {
  enumerable: true,
  get: function get() {
    return _umiRequest.default;
  }
});

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _wrapNativeSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/wrapNativeSuper"));

require("@alifd/next/es/message/style");

var _message = _interopRequireDefault(require("@alifd/next/es/message"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

require("@alifd/next/es/notification/style");

var _notification = _interopRequireDefault(require("@alifd/next/es/notification"));

var _umiRequest = _interopRequireWildcard(require("umi-request"));

var _csrf = _interopRequireDefault(require("./interceptor/csrf"));

var _headers = _interopRequireDefault(require("./interceptor/headers"));

var _urlPrefix = _interopRequireDefault(require("./interceptor/urlPrefix"));

var _noCache = _interopRequireDefault(require("./interceptor/noCache"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var codeMessage = {
  200: '服务器成功返回请求的数据。',
  201: '新建或修改数据成功。',
  202: '一个请求已经进入后台排队（异步任务）。',
  204: '删除数据成功。',
  400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
  401: '用户没有权限（令牌、用户名、密码错误）。',
  403: '用户得到授权，但是访问是被禁止的。',
  404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
  406: '请求的格式不可得。',
  410: '请求的资源被永久删除，且不会再得到的。',
  422: '当创建一个对象时，发生一个验证错误。',
  500: '服务器发生错误，请检查服务器。',
  502: '网关错误。',
  503: '服务不可用，服务器暂时过载或维护。',
  504: '网关超时。'
};
var LOGIN_PATH = window._loginPath_ || '/login';
var PAGE403 = window._page403_ || '/403';

function showError(opts) {
  if (_notification.default && typeof _notification.default.error === 'function') {
    _notification.default.error(opts);
  } else if (_notification.default && typeof _notification.default.open === 'function') {
    _notification.default.open(_objectSpread(_objectSpread({}, opts), {}, {
      type: 'error'
    }));
  } else {
    _message.default.error(opts);
  }
}

var AdminRequestError = /*#__PURE__*/function (_Error) {
  (0, _inherits2.default)(AdminRequestError, _Error);

  var _super = _createSuper(AdminRequestError);

  function AdminRequestError(message, code, raw, ctx) {
    var _this;

    (0, _classCallCheck2.default)(this, AdminRequestError);
    _this = _super.call(this, message);
    _this.name = 'AdminRequestError';

    if (code) {
      _this.code = code;
    }

    if (raw) {
      _this.raw = raw;
    }

    if (ctx && ctx.req) {
      _this.request = ctx.req;
    }

    return _this;
  }

  (0, _createClass2.default)(AdminRequestError, [{
    key: "toString",
    value: function toString() {
      return this.message; // 应测试、@尽流需求，不展示 code
      // const code = typeof this.code !== 'undefined' ? `(errorCode: ${this.code})` : '';
      // return `${this.message} ${code}`;
    }
  }]);
  return AdminRequestError;
}( /*#__PURE__*/(0, _wrapNativeSuper2.default)(Error));

function goTo(url) {
  if (window.umiRouter) {
    window.umiRouter.push(url);
  } else {
    if (window.__hashHistory__) {
      location.href = "/#".concat(url);
    } else {
      location.href = url;
    }
  }
}
/**
 * 异常处理程序
 */


var errorHandler = function errorHandler(error) {
  var message = '';
  var errorDesc = '';
  var errorCode; // 请求的配置参数

  var requestOptions = error.request && error.request.options || {}; // 请求的额外配置参数

  var extraRequestOptions = requestOptions.extraOptions || {};

  if (error instanceof AdminRequestError) {
    message = error.toString();
    errorCode = error.code;
  } else {
    var _error$response = error.response,
        response = _error$response === void 0 ? {} : _error$response;
    var status = response.status,
        url = response.url;
    var errorText = codeMessage[status] || response.statusText;
    errorCode = status;
    var msgList = [];
    if (status) msgList.push(status);
    if (url) msgList.push(": ".concat(url));
    errorDesc = msgList.join('');
    message = errorText;
  }

  var curUrl = window.location.href;

  if (errorCode === '401' || errorCode === 401) {
    if (window.__autoLogin__) {
      if (!curUrl.includes(LOGIN_PATH)) {
        goTo("".concat(LOGIN_PATH, "?goto=").concat(encodeURIComponent(curUrl)));
        return;
      } else {
        // 已经是登录页了，那么也停止，不需要再 log 错误
        return;
      }
    }
  } else if (errorCode === '403' || errorCode === 403) {
    goTo(PAGE403);
    return;
  }

  var noticeOpts = {
    content: message || codeMessage[503]
  };

  if (extraRequestOptions) {
    var errorTitle = extraRequestOptions.errorTitle,
        showErrorTitle = extraRequestOptions.showErrorTitle;

    if (errorTitle) {
      noticeOpts.title = errorTitle;
    } else if (showErrorTitle) {
      noticeOpts.title = "\u8BF7\u6C42\u9519\u8BEF ".concat(errorDesc);
    }
  } // 不设置则默认自动展示错误信息


  if (extraRequestOptions.autoShowError !== false) {
    showError(noticeOpts);
  }

  throw error;
};
/**
 * 配置request请求时的默认参数
 */


var wrapRequest = (0, _umiRequest.extend)({
  errorHandler: errorHandler,
  // 默认错误处理
  credentials: 'include',
  // 默认请求是否带上cookie
  cache: 'no-store' // 不缓存

});
wrapRequest.interceptors.request.use(_csrf.default);
wrapRequest.interceptors.request.use(_noCache.default);
wrapRequest.interceptors.request.use(_headers.default);
wrapRequest.interceptors.request.use(_urlPrefix.default);
wrapRequest.use( /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(ctx, next) {
    var _ctx$res, res, _res$success, success;

    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return next();

          case 2:
            // https://yuque.antfin-inc.com/xgztel/fed/ue6sux#7dc79549
            _ctx$res = ctx.res, res = _ctx$res === void 0 ? {} : _ctx$res;
            _res$success = res.success, success = _res$success === void 0 ? false : _res$success;

            if (success) {
              _context.next = 8;
              break;
            }

            throw new AdminRequestError(res.errorMsg || codeMessage['500'], res.errorCode, res, ctx);

          case 8:
            ctx.res = res.data;

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
var _default = wrapRequest;
exports.default = _default;